var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      class: _vm.$page.props.staffView ? null : "container",
      attrs: { page: "/help-categories", pageTitle: "Help" },
    },
    [
      _c(
        "v-container",
        {
          staticClass: "animate__animated animate__fadeIn",
          attrs: { fluid: "" },
        },
        [
          _c(
            "v-row",
            { staticClass: "mb-4", attrs: { justify: "space-around" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8", md: "6", lg: "4" } },
                [_c("Search")],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            _vm._l(_vm.categories, function (card) {
              return _c(
                "v-col",
                {
                  key: card.id,
                  attrs: { cols: "12", sm: "6", md: "4", lg: "3" },
                },
                [
                  _c("v-hover", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ hover }) {
                            return [
                              _c(
                                "v-card",
                                {
                                  staticClass: "soli-round",
                                  class: {
                                    "on-hover": hover,
                                  },
                                  staticStyle: { border: "none" },
                                  attrs: {
                                    elevation: hover ? 12 : 2,
                                    hover: "",
                                    light: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.visit(card)
                                    },
                                  },
                                },
                                [
                                  _vm.$vuetify.breakpoint.smAndUp
                                    ? _c(
                                        "div",
                                        { staticClass: "contents" },
                                        [
                                          _c(
                                            "v-img",
                                            {
                                              staticClass:
                                                "align-end half-round",
                                              attrs: {
                                                height: 196,
                                                src: card.imagePath
                                                  ? `/api/image-service/240x240/${card.imagePath}`
                                                  : card.photo_url,
                                                gradient:
                                                  "to bottom, rgb(255 255 255 / 0%), rgba(25, 73, 114, .75)",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-card-title",
                                                {
                                                  staticClass:
                                                    "white--text font-weight-bold text-h5",
                                                },
                                                [_vm._v(_vm._s(card.title))]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-actions",
                                            {
                                              staticClass:
                                                "flex justify-end pa-3",
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "soli-round",
                                                  attrs: {
                                                    outlined: "",
                                                    color: "primary",
                                                  },
                                                },
                                                [_vm._v("View Articles")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$vuetify.breakpoint.xsOnly
                                    ? _c(
                                        "v-card-actions",
                                        [
                                          _c(
                                            "v-list",
                                            [
                                              _c(
                                                "v-card-title",
                                                {
                                                  staticClass:
                                                    "font-weight-bold soli-grey pb-0",
                                                },
                                                [_vm._v(_vm._s(card.title))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "soli-round ml-1",
                                                  attrs: {
                                                    text: "",
                                                    small: "",
                                                    color: "primary",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        underline: hover,
                                                      },
                                                    },
                                                    [_vm._v("View Article")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { small: "" } },
                                                    [_vm._v("chevron_right")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-avatar",
                                            {
                                              staticClass: "soli-round",
                                              attrs: { size: "96" },
                                            },
                                            [
                                              _c("v-img", {
                                                staticClass: "align-end",
                                                attrs: {
                                                  src: card.imagePath
                                                    ? `/api/image-service/96x96/${card.imagePath}`
                                                    : card.photo_url,
                                                  gradient:
                                                    "to bottom, rgb(255 255 255 / 0%), rgba(25, 73, 114, .75)",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }